import { postAPI } from '../../../utils/utils';

// L'ordre de proves s'envia com el que ha fet la persona («posa X davant de Y»)
// i el servidor ho aplica sobre l'ordre que té ara. Enviar la llista sencera
// deixava que una pantalla sense l'ordre carregat el trepitgés per a tothom.

const sameSlice = (a, aStart, aEnd, b, bStart) => {
    for (let i = 0; i <= aEnd - aStart; i += 1) if (a[aStart + i] !== b[bStart + i]) return false;
    return true;
};

// Quin element s'ha mogut entre dues llistes i al costat de quin ha quedat.
// Null si no és exactament un sol moviment.
export const describeMove = (previous, next) => {
    if (!Array.isArray(previous) || !Array.isArray(next) || previous.length !== next.length) return null;
    let start = 0;
    while (start < previous.length && previous[start] === next[start]) start += 1;
    if (start === previous.length) return null;
    let end = previous.length - 1;
    while (end > start && previous[end] === next[end]) end -= 1;
    if (next[start] === previous[end] && sameSlice(previous, start, end - 1, next, start + 1)) {
        return { prova: next[start], before: next[start + 1] };
    }
    if (next[end] === previous[start] && sameSlice(previous, start + 1, end, next, start)) {
        return { prova: next[end], after: next[end - 1] };
    }
    return null;
};

// Mentre hi ha canvis propis en camí, la pantalla ja mostra el resultat: un
// ordre que arribi d'un altre lloc es deixa per al final, i aleshores es mostra
// l'última resposta del servidor (i es torna a demanar si n'ha arribat cap altre).
export const createOrderEditTracker = () => {
    let pending = 0;
    let missed = false;
    let latest = null;
    return {
        start() {
            pending += 1;
        },
        finish(order = null) {
            pending = Math.max(0, pending - 1);
            if (order) latest = order;
            if (pending > 0) return { apply: null, refresh: false };
            const result = { apply: latest, refresh: missed };
            latest = null;
            missed = false;
            return result;
        },
        incoming() {
            if (pending === 0) return true;
            missed = true;
            return false;
        },
    };
};

// Servidors d'abans de /order_edit responen 404: llavors s'envia l'ordre sencer com sempre.
export const postOrderEdit = ({ event, edit, socket, userId, onOrder, onUnsupported, onFailure }) => {
    const body = { ...edit, userId: userId ?? null, socketId: socket?.id ?? null };
    postAPI(`/order_edit/${event}`, body,
        res => onOrder(Array.isArray(res?.order) ? res.order : null),
        error => (error?.status === 404 ? onUnsupported() : onFailure(error)));
};
